import {actionTypes} from '../reducers/DataTableWithFiltersOptionsReducer';
import axios from 'axios';

export const GET_SHUMA_PROPERTY_TYPES = '/generalData/getPropertyTypeIDs';
export const GET_ALL_SHUMA_TYPES = 'generalData/getAllShumaTypes';
export const GET_FIRM_USERS = 'generalData/getFirmUsersOptions';

export const getShumaPropertyTypes = () => dispatch => {
  return axios.post(GET_SHUMA_PROPERTY_TYPES)
    .then(response => {
      const {body, errorCode} = response.data;
      if (errorCode < 0) throw new Error();
      const {propertyTypes} = body;

      dispatch({
        type: actionTypes.getPropertyTypes,
        payload: {propertyTypes},
      });
    })
    .catch(error => {
      error.clientMessage = 'Can\'t find data';
      dispatch({
        type: actionTypes.catchError,
        payload: error,
      });
    });
};

export const getAllShumaTypes = () => dispatch => {
  return axios.post(GET_ALL_SHUMA_TYPES)
    .then(response => {
      const {body, errorCode} = response.data;
      if (errorCode < 0) throw new Error();
      const {shumaTypes} = body;

      dispatch({
        type: actionTypes.getAllShumaTypes,
        payload: {shumaTypes},
      });

      return shumaTypes
    })
};

export const getFirmUsers = () => dispatch => {
  return axios.post(GET_FIRM_USERS)
    .then(response => {
      const {body, errorCode} = response.data;
      if (errorCode < 0) throw new Error();
      const {users} = body;

      dispatch({
        type: actionTypes.getFirmUsers,
        payload: {users},
      });

      return users
    })
};

